export default "__VITE_ASSET__D_E0jRap__"